<div class="modal-body">
  <nf-form-control>
    <textarea rows="5" class="form-control" [(ngModel)]="data"></textarea>
  </nf-form-control>
</div>
<div class="modal-footer">
  <button nf-button="cancel" (click)="activeModal.close()"></button>
  <button nf-button="submit" (click)="submitBulkEntry()">Enter</button>
</div>
